import { render } from "./EventPartLinkedDocuments.vue?vue&type=template&id=26e1470e"
import script from "./EventPartLinkedDocuments.vue?vue&type=script&lang=ts"
export * from "./EventPartLinkedDocuments.vue?vue&type=script&lang=ts"

import "./EventPartLinkedDocuments.vue?vue&type=style&index=0&id=26e1470e&lang=scss"
script.render = render

export default script